/* eslint-disable import/no-named-as-default-member */
/* eslint-disable @typescript-eslint/no-explicit-any */

import dayjs from 'dayjs'

import { useFetchQuery } from './useFetchQuery'
import { FormEvent as FormEventApi } from '../API'
import { formEventBySlug } from '../api/queries'
import { fetchQuery } from '../utils/ApiUtils'

type FormEvent = Omit<Exclude<FormEventApi, null>, '__typename'>

interface Props {
  slug: string | null | undefined
}
const useFormEventDetails = ({ slug }: Props) => {
  const { data: event, apiLoading, apiError } = useFetchQuery(
    async () => {
      const { items } = (await fetchQuery('formEventBySlug', formEventBySlug, {
        slug,
        filter: { registrationCutOff: { gt: dayjs().tz('Asia/Manila') } },
      })) as unknown as { items: FormEvent[] }

      if (items.length > 0) {
        const item = items[0]
        item.tshirtFees = JSON.parse(JSON.parse(item.tshirtFees))
        const atdInfoParsed = JSON.parse(JSON.parse(item.atdInfo))
        item.atdInfo = {
          label: `Authority to deduct form for payment through salary deduction`,
          text: `I, the undersigned employee hereby authorize the employer paymaster to make deductions from my salary as payment for the t-shirt that I will use for ${
            item.name
          }. Total amount of payment shall be deductible in 2 quincenas starting from ${dayjs(
            item.registrationCutOff,
          )
            .add(1, 'month')
            .tz('Asia/Manila')
            .format('MMMM 15, YYYY')}.`,
          ...atdInfoParsed,
        }
        return item
      }
      return undefined
    },
    [slug],
    'Fail to load event',
  )

  return { event, apiLoading, apiError }
}

export default useFormEventDetails
